// extracted by mini-css-extract-plugin
var _1 = "PjegA";
var _2 = "IHeQ2";
var _3 = "IpeV7";
export { _1 as "base", _2 as "theme-highlight", _3 as "theme-light" }
